import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import "./UserProfile";
import UserProfile from "./UserProfile";
import { DialogContent } from "@mui/material";

export default function ProfilePopup({open, onClose }) {
//   const [open, setOpen] = React.useState(false);
//   React.useEffect(() => {
//     setOpen(true);
//   }, []);
//   const handleClose = () => {
//     setOpen(false);
//   };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        disableEnforceFocus
        maxWidth="sm" // Adjust size dynamically
        fullWidth // Makes width responsive
        // sx={{ "& .MuiDialog-paper": {  } }}
        onClose={onClose}
      >
        <DialogContent>
        <UserProfile onClose={onClose} />
        </DialogContent>
        {/* <DialogActions>
          <Button onClick={handleClose}>Disagree</Button>
          <Button onClick={handleClose} autoFocus>
            Agree
          </Button>
        </DialogActions> */}
      </Dialog>
    </React.Fragment>
  );
}
